import React from "react";
import style from "./ShrinkExpandButton.module.scss";
import cls from "classnames";
import { ShrinkExpandBloc } from "../ShrinkExpandButton/ShrinkExpandBloc";
import { useCreation } from "ahooks";
var EXPAND = "View more";
var SHRINK = "View less";
export var ShrinkExpandButton = function ShrinkExpandButton(props) {
  var _props$expanded, _props$readonlyStyle, _props$expanded2;
  var bloc = useCreation(function () {
    return new ShrinkExpandBloc(props.expanded);
  }, []);
  var stateClassName = (_props$expanded = props.expanded) !== null && _props$expanded !== void 0 && _props$expanded.value ? style.expanded : style.shrinked;
  return /*#__PURE__*/React.createElement("div", {
    className: cls(style.shrinkExpandButton, style[props.parentClassName || ""]),
    onClick: bloc.toggleExpanded
  }, /*#__PURE__*/React.createElement("div", {
    style: (_props$readonlyStyle = props.readonlyStyle) !== null && _props$readonlyStyle !== void 0 ? _props$readonlyStyle : {},
    className: cls(stateClassName, style.shrinkExpandText, style[props.parentClassName || ""])
  }, (_props$expanded2 = props.expanded) !== null && _props$expanded2 !== void 0 && _props$expanded2.value ? SHRINK : EXPAND), /*#__PURE__*/React.createElement("div", {
    className: cls(style.icon, stateClassName, style[props.parentClassName || ""])
  }));
};